Pixlee.module('SlideShowApp', function(SlideShowApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    SlideShowApp.on('start', function(options) {
        new SlideShowApp.Show.Controller(options);
    });
});